export default __webpack_public_path__ + "static/media/login-bg-42.d2eafd19.jpg";